/**
 * Hebrew labels for an explicit Hubwayz/Mishor `items[].bedding` code.
 * Room names such as "Deluxe Twin" are never parsed into a bed type.
 */
const BEDDING_HE = Object.freeze({
  single: "מיטה יחיד",
  twin: "2 מיטות יחיד",
  double: "מיטה זוגית אחת",
  king: "מיטת קינג",
  queen: "מיטת קווין",
  triple: "מיטה לשלושה",
  quadruple: "מיטה לארבעה",
});

function beddingTokens(raw) {
  if (raw == null || raw === "") return [];
  const list = Array.isArray(raw) ? raw : [raw];
  return list
    .map((value) => (value == null ? "" : String(value).trim()))
    .filter(Boolean);
}

/** Explicit bed fields only. Missing fields stay empty. */
export function readExplicitBedding(item) {
  if (!item || typeof item !== "object") return [];
  const raw =
    item.bedding ?? item.bedType ?? item.bedTypes ?? item.beds ?? null;
  return beddingTokens(raw);
}

export function formatExplicitBeddingHe(values) {
  const tokens = beddingTokens(values);
  if (!tokens.length) return null;
  return tokens
    .map((token) => BEDDING_HE[token.toLowerCase()] || token)
    .join(" · ");
}

/** Supplier bedding text, unchanged. Room cards do not translate bed types. */
export function formatSupplierBeddingLabel(values) {
  const tokens = beddingTokens(values);
  if (!tokens.length) return null;
  return tokens.join(" · ");
}

/**
 * Room name and bedding stay separate. "Standard Double" plus bedding "double"
 * must not read as one word.
 */
export function hubwayzRoomHeading(name, beddingLabel) {
  const roomName = String(name || "").trim();
  const bedding = String(beddingLabel || "").trim();
  return {
    roomName,
    bedding,
    accessible: [roomName, bedding].filter(Boolean).join(" · "),
  };
}
